import { FamilyGroup } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getFamilyGroups = async (familyId: string, locale: string): Promise<FamilyGroup[]> => {
  const url = `/family/${familyId}/groups?include=available&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<FamilyGroup[]>(url);
  return response.data;
};
